//#region src/helpers/video-url-parser.ts
var e = class {
	isValid = !1;
	provider = "";
	id = "";
}, t = [
	{
		provider: "youtube",
		displayName: "YouTube",
		regex: /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})(?:\S+)?$/
	},
	{
		provider: "youtube",
		displayName: "YouTube",
		regex: /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/shorts\/)([\w-]{11})(?:\S+)?$/
	},
	{
		provider: "vimeo",
		displayName: "Vimeo",
		regex: /vimeo\..*?\/(\d+)\/([\w-]+)/i
	},
	{
		provider: "vimeo",
		displayName: "Vimeo",
		regex: /vimeo\..*?\/(\d+)\?h=([\w-]+)/i
	},
	{
		provider: "vimeo",
		displayName: "Vimeo",
		regex: /vimeo\..*?\/(\d+)(?:\/)?/i
	},
	{
		provider: "wistia",
		displayName: "Wistia",
		regex: /wistia\..*\/([^?]+)\??.*/i
	},
	{
		provider: "loom",
		displayName: "Loom",
		regex: /(?:use)?loom\..*\/([^?]+)\??.*/i
	},
	{
		provider: "vidyard",
		displayName: "Vidyard",
		regex: /vidyard\..*\/([^?]+)\??.*/i
	},
	{
		provider: "brightcove",
		displayName: "Brightcove",
		regex: /players\.brightcove\.net\/([^/]+)\/.*videoId=([\w-]+)/i
	},
	{
		provider: "jwplayer",
		displayName: "JW Player",
		regex: /(?:cdn|content)\.(?:jwplayer|jwplatform)\.com\/players\/([\w-]+)\.html/i
	},
	{
		provider: "microsoftstream",
		displayName: "Microsoft Stream",
		regex: /web\.microsoftstream\.com\/embed\/video\/([\w-]+)/i
	},
	{
		provider: "microsoftstream",
		displayName: "Microsoft Stream",
		regex: /^(?:https?:\/\/)?([\w-]+)\.sharepoint\.com\/:v:\/(.*)/i
	},
	{
		provider: "synthesia",
		displayName: "Synthesia",
		regex: /share\.synthesia\.io\/embeds\/videos\/([\w-]+)/i
	},
	{
		provider: "synthesia",
		displayName: "Synthesia",
		regex: /share\.synthesia\.io\/([\w-]+)/i
	},
	{
		provider: "guidde",
		displayName: "Guidde",
		regex: /embed\.app\.guidde\.com\/playbooks\/([\w-]+)/i
	},
	{
		provider: "descript",
		displayName: "Descript",
		regex: /share\.descript\.com\/(?:embed|view)\/([\w-]+)/i
	},
	{
		provider: "guideflow",
		displayName: "Guideflow",
		regex: /app\.guideflow\.com\/(?:embed|video|player)\/([\w-]+)/i
	},
	{
		provider: "supademo-showcase",
		displayName: "Supademo",
		regex: /app\.supademo\.com\/showcase\/embed\/([\w-]+)/i
	},
	{
		provider: "supademo-showcase",
		displayName: "Supademo",
		regex: /app\.supademo\.com\/showcase\/([\w-]+)/i
	},
	{
		provider: "supademo",
		displayName: "Supademo",
		regex: /app\.supademo\.com\/embed\/([\w-]+)/i
	},
	{
		provider: "supademo",
		displayName: "Supademo",
		regex: /supademo\.com\/demo\/([\w-]+)/i
	},
	{
		provider: "arcade",
		displayName: "Arcade",
		regex: /app\.arcade\.software\/share\/([\w-]+)/i
	},
	{
		provider: "arcade",
		displayName: "Arcade",
		regex: /demo\.arcade\.software\/([\w-]+)/i
	},
	{
		provider: "supercut",
		displayName: "Supercut",
		regex: /supercut\.video\/share\/([\w-]+)\/([\w-]+)/i
	},
	{
		provider: "supercut",
		displayName: "Supercut",
		regex: /supercut\.ai\/share\/([\w-]+)\/([\w-]+)/i
	},
	{
		provider: "supercut",
		displayName: "Supercut",
		regex: /supercut\.ai\/embed\/([\w-]+)\/([\w-]+)/i
	},
	{
		provider: "clueso",
		displayName: "Clueso",
		regex: /watchclueso\.com\/embed\/([\w-]+)/i
	},
	{
		provider: "hubspot",
		displayName: "HubSpot Video",
		regex: /player\.mux\.com\/([\w-]+)/i
	},
	{
		provider: "tella",
		displayName: "Tella",
		regex: /(?:www\.)?tella\.tv\/video\/([\w-]+)/i
	},
	{
		provider: "storylane",
		displayName: "Storylane",
		regex: /(?:app\.)?storylane\.(?:io|com)\/(?:demo|share)\/([\w-]+)/i
	}
], n = [...new Set(t.map((e) => e.displayName))], r = "|";
function i(n) {
	let i = new e();
	return n && (n = n.trim(), t.some((e) => {
		let t = n.match(e.regex);
		if (t) {
			let [, ...n] = t;
			return i.provider = e.provider, i.id = n.join(r), i.isValid = !0, !0;
		} else return !1;
	})), i;
}
function a(e, t) {
	let [n, ...i] = t.split(r);
	switch (e) {
		case "youtube": return `https://www.youtube.com/embed/${n}?rel=0`;
		case "vimeo": return i.length === 0 ? `https://player.vimeo.com/video/${n}` : `https://player.vimeo.com/video/${n}?h=${i[0]}`;
		case "wistia": return `https://fast.wistia.net/embed/iframe/${n}`;
		case "loom": return `https://www.loom.com/embed/${n}`;
		case "vidyard": return `https://play.vidyard.com/${n}`;
		case "brightcove": return `https://players.brightcove.net/${n}/default_default/index.html?videoId=${i[0]}`;
		case "jwplayer": return `https://cdn.jwplayer.com/players/${n}.html`;
		case "microsoftstream": return i.length === 0 ? `https://web.microsoftstream.com/embed/video/${n}` : `https://${n}.sharepoint.com/:v:/${i[0]}`;
		case "synthesia": return `https://share.synthesia.io/embeds/videos/${n}`;
		case "guidde": return `https://embed.app.guidde.com/playbooks/${n}`;
		case "descript": return `https://share.descript.com/embed/${n}`;
		case "guideflow": return `https://app.guideflow.com/embed/${n}`;
		case "supademo": return `https://app.supademo.com/embed/${n}`;
		case "supademo-showcase": return `https://app.supademo.com/showcase/embed/${n}`;
		case "arcade": return `https://demo.arcade.software/${n}?embed`;
		case "supercut": return `https://supercut.ai/embed/${n}/${i[0]}`;
		case "clueso": return `https://watchclueso.com/embed/${n}`;
		case "hubspot": return `https://player.mux.com/${n}`;
		case "tella": return `https://www.tella.tv/video/${n}/embed`;
		case "storylane": return `https://app.storylane.io/demo/${n}`;
		default: throw Error(`Video provider ${e} not supported`);
	}
}
//#endregion
export { n as VIDEO_PROVIDER_DISPLAY_NAMES, a as generateVideoUrl, i as parseUrl };
